<template>
  <div class="Index">
    <closeZone></closeZone>
    <div class="deerAnimee">
      <div class="title"></div>
    </div>
    <img
      @click="goHome"
      class="module_share"
      src="@/assets/classificationImg/home.png"
      alt=""
    />
    <div class="module_box">
      <div class="module module_1" @click.stop.prevent="goHealth">
        <div class="left_text">医疗健康</div>
      </div>
      <div class="module module_2" @click.stop.prevent="goSociety">
        <div class="left_text">社会保障</div>
      </div>
      <div class="module module_3" @click.stop.prevent="goTraffic">
        <div class="left_text">交通出行</div>
      </div>
      <div class="module module_4" @click.stop.prevent="goLife">
        <div class="left_text">生活缴费</div>
      </div>
      <div class="module module_5" @click.stop.prevent="goShopping">
        <div class="left_text">购物消费</div>
      </div>

    </div>
    <!--模式切换-->
    <div v-show="isVip === true ? true : false" class="btn-toggle-content" @click="toggleList" >
      <div class="btn-toggle-content-1">
        <img
          class="btn-toggle-content-icon"
          src="@/assets/modify/mainBg/btn-bg-192-list.png"
          alt=""
        />
        <div class="btn-toggle-content-title">切换为列表模式</div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper" @click.stop="show = false">
        <div class="block">
          <div class="image">
            <!-- <svg-icon icon-class="arrows" style="font-size: 50px;"></svg-icon> -->
          </div>
          <div class="content">
            <div>1.点击右上角 <span>...</span></div>
            <div>2.选择浏览器打开</div>
            <div>3.点击转发按钮</div>
          </div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>
<script>
import VanOverlay from "vant/lib/overlay";
import "vant/lib/overlay/style";

import VanPopup from "vant/lib/popup";
import 'vant/lib/popup/style'

import wx from 'weixin-js-sdk'
// import router from "@/router";
export default {
  name: "index",
  components: {
    VanOverlay,
    VanPopup,
  },
  data() {
    return {
      show: false,
      isBtun: false,
      isVip: false,
      //畅享权益
      direction: 'btt',
      drawer: false,
      showPopup:false,
    };
  },
  created() {

  },

  mounted() {
    this.isVip = this.$store.getters.isVip
    console.log(this.isVip,'状态')
  },
  beforeDestroy() {},

  computed:{
    isVipUser() {
      return this.isVip
    }
  },

  methods: {
    // 模式切换
    toggleList () {
      this.$router.push({
        path: '/list',
      })
    },

    async goHealth() {
      this.$router.push({
        path: "/health/healthIndex",
      });
    },
    async goSociety() {
      this.$router.push({
        path: "/society/societyIndex",
      });
    },
    async goLife() {
      this.$router.push({
        path: "/life/lifeIndex",
      });
    },
    async goTraffic() {
      this.$router.push({
        path: "/traffic/trafficIndex",
      });
    },
    async goShopping() {
      this.$router.push({
        path: "/shopping/shoppingIndex",
      });
    },
    goHome() {
      // 使用 replace 而不是 push，并跳转到根路径
      this.$router.replace("/").then(() => {
        // 强制刷新页面（可选，确保完全重置应用状态）
        // window.location.reload(); 
      });
    },
  },
};
</script>
<style scoped lang="less">
.popup-info{
  width: 100%;
  height: 85vh;
  position: relative;
}
.popup-info-close{
  position: absolute;
  top: 11%;
  right: 1.5%;
  width: 15%;
  height: 9%;
  background: url(@/assets/zone/closeQuanyi.png) no-repeat center;
  background-size: 100% 100%;
}
.popup-info-bk{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(@/assets/zone/order.png) no-repeat center;
  background-size: 100% 100%;
}
.popup-info-quanyi{
  position: absolute;
  top: 30%;
  left: 13%;
  width: 75%;
  height: 45%;
  background: url(@/assets/zone/quanyi.png) no-repeat center;
  background-size: 100% 100%;
}
.popup-info-vip{
  position: absolute;
  top: 80%;
  left: 20%;
  width: 70%;
  height:19%;
  background: url(@/assets/zone/vip.png) no-repeat center;
  background-size: 100% 100%;
}
.van-popup {
  border-radius: 20px 20px 0 0;
  background: none !important;
}

.btn-toggle-content {
  position: absolute;
  bottom: 100px;
  left: 50%;
  transform: translate(-50%);
  width: 67vw;
  height: 100px;
  background: url(@/assets/modify/mainBg/btn-bg.png) no-repeat center;
  background-size: 100% 100%;
  border-radius: 0px;
  // margin: 0 auto;
  .btn-toggle-content-1 {
    width: 63vw;
    height: 80px;
    line-height: 80px;
    background: url(@/assets/modify/mainBg/btn-bg-192.png) no-repeat center;
    background-size: 100% 100%;
    border-radius: 0px;
    margin: 0 auto;
    position: relative;
    top: 10px;
    display: flex;
    .btn-toggle-content-icon {
      width: 50px;
      height: 50px;
      line-height: 50px;
      position: absolute;
      top: 20%;
      left: 15%;
    }
    .btn-toggle-content-title {
      font-family: SourceHanSansSC-Regular-2;
      font-size: 35px;
      color: #fdf4dd;
      margin-left: 140px;
    }
  }
}
</style>
<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(@/assets/modify/mainBg/rectangle_20250106.png) no-repeat
    center;
  background-size: 100% 100%;
  border-radius: 0px;
}
.deerAnimee {
  position: absolute;
  top: 10px;
  left: 80px;
  width: 180px;
  height: 180px;
  background: url("@/assets/classificationImg/deer.gif") no-repeat;
  background-size: 100% 100%;
  z-index: 1;
}
.module_share {
  width: 90px;
  height: 90px;
  position: relative;
  z-index: 100;
  top: 1%;
  left: 2%;
}
.title {
  position: absolute;
  top: 60px;
  left: -10px;
  width: 617px;
  height: 285px;
  background: url("@/assets/classificationImg/classificationImg_title.png") no-repeat
    center;
  background-size: 100% 100%;
  z-index: 9;
}

.module_box {
  position: absolute;
  top: 380px;
  left: 50%;
  transform: translate(-50%);
  padding: 0 10px;
  .module {
    cursor: pointer;
    display: flex;
    align-items: center;
    // justify-content: space-evenly;
    width: 670px;
    height: 120px;
    border-radius: 15px;
    margin-bottom: 20px;
    .left_text {
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 40px;
      color: #ffffff;
      line-height: 39px;
      margin-left: 50px;
    }
  }
  .module_1 {
    background: url(@/assets/classificationImg/module_1.png) no-repeat;
    background-size: 100% 100%;
  }
  .module_2 {
    background: url(@/assets/classificationImg/module_2.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .left_lock{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("@/assets/zone/lock.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .module_3 {
    background: url(@/assets/classificationImg/module_3.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .left_lock{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("@/assets/zone/lock.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .module_4 {
    background: url(@/assets/classificationImg/module_4.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .left_lock{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("@/assets/zone/lock.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .module_5 {
    background: url(@/assets/classificationImg/module_5.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .left_lock{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("@/assets/zone/lock.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}



.wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
}

.block {
  width: 100%;
  position: relative;
  font-size: 40px;
  .image {
    position: absolute;
    right: 30px;
    top: 10px;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    margin-top: 100px;
    color: #fff;
    div {
      span {
        font-size: 50px;
        font-weight: bold;
      }
    }
  }
}
</style>
